import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-icon-external-link',
  templateUrl: './icon-external-link.component.html',
  styleUrls: ['./icon-external-link.component.scss'],
  standalone: true,
})
export class IconExternalLinkComponent {
  @Input() color = '#E8EEF2';
  @Input() width = '16';
  @Input() height = '16';
}
